import { SplitTextAnim } from '../modules/SplitTextAnim';
import { Tile } from '../modules/Tile';
import { autobind } from 'frontools/decorators/Autobind';
import { timeout } from 'frontools/decorators/Timeout';
import { debounce } from 'frontools/decorators/Debounce';
import VanillaUtils from 'frontools/utils/VanillaUtils';
import ScrollUtils from 'frontools/utils/ScrollUtils';
import VideoPlayer from 'frontools/medias/video/VideoPlayer';
import Context from 'frontools/core/Context';
import Breakpoint from 'frontools/core/Breakpoint';
import AbstractPage from './AbstractPage';
import { FilterNav } from '../modules/FilterNav';
import { ScrollTo } from "./ScrollTo";
import LazyLoadManager, { LazyLoadManagerOptions } from 'frontools/medias/image/LazyLoadManager';


declare var Swiper;
declare var dataLayer;

export class Accueil extends AbstractPage {

    private _heroSwiper         : any;
    private _splitTextAnim      : SplitTextAnim;
    private _filterNav          : FilterNav;

    private _elHero             : HTMLElement;
    private _elSlides           : NodeListOf<HTMLElement>;
    private _elSwiperPagination : HTMLElement;
    private _elFirstMedia       : HTMLElement;
    private _elVideos           : NodeListOf<HTMLElement>;
    private _elNavFilter        : HTMLElement;

    private _videos             : Array<VideoPlayer>            = [];
   
    constructor(private _type?:string) {
        super();

        this._elHero = document.querySelector('.hero_main') as HTMLElement;
        this._elGrid = document.querySelector('[data-grid]') as HTMLElement;

        if (this._elHero) {
            this._elSwiperPagination = this._elHero.querySelector('.swiper-pagination') as HTMLElement;
            this._elSlides = this._elHero.querySelectorAll('.swiper-slide') as NodeListOf<HTMLElement>;
            this._elFirstMedia = this._elSlides[0] as HTMLElement;

            this._createSlidesMedias();        
        }

        this._elNavFilter = document.querySelector('[data-filter-nav]') as HTMLElement;
        if (this._elNavFilter) {
            this._filterNav = new FilterNav(this._elNavFilter);
            this._filterNav.addListener(FilterNav.CHANGE, this._onFilterChange)
        }
        
        if (this._type == 'p_categorie' || this._type == 'p_createur' || window.location.hash == '#filt') {
            let urlWithoutHash = window.location.href.split('#')[0];
            window.history.replaceState(urlWithoutHash, urlWithoutHash, urlWithoutHash);
            if (document.readyState != 'loading') this._goToFiltre();
            else document.addEventListener('DOMContentLoaded', this._goToFiltre);
        }
        document.querySelector('[data-main-nav] .links_wrapper .active').addEventListener('click', (e) => {
            e.preventDefault();
            new ScrollTo(document.querySelector('#filt') as HTMLElement);
        });

        let anchorTopLink = document.querySelector('[data-anchor-top]') as HTMLElement;
        anchorTopLink.addEventListener('click', (e) => {
            e.preventDefault();
            new ScrollTo(document.querySelector('#filt') as HTMLElement);
        });

         this._parseGTM();

         this._quotes.hide();
         if (this._elHero) {
            var heroBottom = VanillaUtils.getOffsetRect(this._elHero).top+this._elHero.offsetHeight;
            ScrollUtils.registerElement(heroBottom, {
                offset: 0,
                before: () => { 
                    this._quotes.hide();
                    TweenMax.set(this._elHero, {display: 'block'});
                    if (this._heroSwiper) this._heroSwiper.update();
                },
                after: () => { 
                    this._quotes.show();
                    TweenMax.set(this._elHero, {display: 'none'});
                }
            })
        }
    }
    
    @autobind
    private _goToFiltre(){
        setTimeout(()=>{
            let elementNav = document.querySelector('[data-filter-nav]') as HTMLElement;
            if(elementNav) new ScrollTo(elementNav);
            ScrollUtils.triggerEventOf(window);             
        }, 600)
    }

    @autobind
    private _onFilterChange(e) {
        new ScrollTo(document.querySelector('#filt') as HTMLElement);
        var gridElements = this._elGrid.querySelectorAll('.g_item') as NodeListOf<HTMLElement>;
        if (gridElements.length) {
            TweenMax.staggerTo(gridElements, 0.1, {opacity:0, x:-20, y:-5}, 0.05, 
                function() {    
                    // On complete all staggers tweens
                    this._onRemoveComplete(e.content);
            }.bind(this));
        } else {
            this._onRemoveComplete(e.content);
        }
    }

    private _parseGTM() {
        var gridElements = this._elGrid.querySelectorAll('.g_item') as NodeListOf<HTMLElement>;
        for (var i = 0; i < gridElements.length; i++) {
            var link = gridElements[i].querySelector('a') as HTMLAnchorElement;
            if (link) {
                let creator = link.getAttribute('data-creator');
                let project = link.getAttribute('data-project');
                link.addEventListener('click', (e) => {   
                    dataLayer.push({
                        eventCategory: 'accueil',
                        eventAction: 'projet',
                        eventLabel: project+'-'+creator,
                        event: 'genericGAEvent'
                    });
                })
            }
        }
    }

    @autobind
    private _onRemoveComplete(content:HTMLElement) {
        if (content.innerHTML) {         
            if (this._masonryGrid) {
                this._masonryGrid.destroy();
                this._masonryGrid = undefined;
                this._destroyTiles();       
            }           
            this._elGrid.innerHTML = content.innerHTML;
            TweenMax.set(this._elGrid.querySelectorAll('.g_item'), {opacity:0, x:-20, y:-5});
            this._createMasonry();
            setTimeout(function() {
                let elements = this._elGrid.querySelectorAll(this._lazyLoadManager.options.selector) as NodeListOf<HTMLElement>;
                this._lazyLoadManager.parseElements(elements);   
                if (!Breakpoint.isLowerThan(Breakpoint.TABLET)) this._createGrid(); 
                TweenMax.staggerTo(this._elGrid.querySelectorAll('.g_item'), 0.1, {opacity:1, x:0, y:0}, 0.05);

                this._parseGTM();
            }.bind(this), 100)  
        }
    }

    private _createSlidesMedias() {
        TweenMax.set(this._elHero.querySelectorAll('[data-animate]'), {opacity:0, x: -50});

        //Sorting randomly slides
        var slides = Array.prototype.slice.call(this._elSlides).sort(function(a, b){return 0.5 - Math.random()}), 
            i = 0;
        while(i < slides.length) {
            this._elSlides[0].parentElement.appendChild(slides[i]);
            i++;
        }

        for (let index = 0; index < this._elSlides.length; index++) {
            let element = this._elSlides[index];
            let video = element.querySelector('.video') as HTMLElement;
            if (!video) continue;
            if (Breakpoint.isLowerThan(Breakpoint.TABLET)) {
                video.classList.remove('.video');   
                let image = document.createElement('IMG') as HTMLImageElement;
                image.src = video.getAttribute('data-img-fallback');
                if (index === 0) image.addEventListener('load', this._onFirstMediaLoaded);
                video.appendChild(image);
            } else {    
                this._videos[index] = new VideoPlayer({
                    target: video,                     
                    volume: 0,
                    fullsize: true,    
                    forceratio: true,
                    position: 'relative',
                    video:{
                        attributes:{ loop:true, autoplay:true, playsinline: true, preload: "auto", muted: true}
                    },
                    callbacks:{ 
                        oncanplay: function(e) {
                            if (index === 0) this._onFirstMediaLoaded();
                            e.target.play();
                        }.bind(this),
                        onerror: (e) => {
                            alert('error')
                        }
                    }
                });
                // (this._videos[index].getVideo() as HTMLVideoElement).setAttribute('webkit-playsinline','true');
            }
        }
    }

    @autobind
    private _onFirstMediaLoaded() {
        if (this._splitTextAnim) return;
        // TweenMax.to()
        TweenMax.to(this._elSlides, 0.6, {opacity:1, ease: Expo.easeOut,onComplete: this._createAnim });
    }

    @autobind
    private _createAnim() {
        var splitText = document.querySelector('[data-split-anim]') as HTMLElement;
        if (splitText) {
            this._splitTextAnim = new SplitTextAnim(splitText);
            this._splitTextAnim.addListener(SplitTextAnim.ENDED, this._createSwiper);
        }
    }

    @autobind
    private _createSwiper() {

        TweenMax.to(this._splitTextAnim.elWrapper, 0.4, {delay: 1, opacity: 0, 
            onComplete: function() {
                this._splitTextAnim.elWrapper.parentNode.removeChild(this._splitTextAnim.elWrapper);
                this._heroSwiper = new Swiper('.hero_main', {   
                    speed: 400,
                    setWrapperSize: true,
                    pagination: '.swiper-pagination',
                    paginationClickable: true,
                    onInit: function(swiper) {
                        TweenMax.staggerTo(swiper.slides[swiper.activeIndex].querySelectorAll('[data-animate]'), 0.4, {x:0, opacity:1},0.2);
                        TweenMax.staggerFromTo(this._elSwiperPagination.querySelectorAll('.swiper-pagination-bullet'), 0.4, {x: -20, delay: 1, opacity:0},{x:0, opacity:1},0.4);
                    }.bind(this),
                    onSlideChangeEnd: function(swiper) {
                        TweenMax.staggerTo(swiper.slides[swiper.activeIndex].querySelectorAll('[data-animate]'), 0.4, {x:0, opacity:1},0.2);
                    }.bind(this)
                });
            }.bind(this)
        });
    }   

    protected onResize() {
            
    }

    protected onResizeMobile() {
        super.onResizeMobile();
    }

    protected onResizeDesktop() {
        super.onResizeDesktop();
    } 
}